import { useState, useEffect, useRef } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { CloudfrontVideoFormat } from '../../videos/CloudfrontVideoFormat';
import './champion.scss';

/**
 * Champion celebration component with two stages:
 * 1. Congratulations screen with confetti, bouncing image, and Joyful Jingle music
 * 2. Influencer affirmation video
 * @param {*} props - { rewardImage, close, background, music, influencerVideo }
 * @returns
 */
export default function Champion(props) {
  const { login } = useSelector((state) => state.loginReducer, shallowEqual);
  const [stage, setStage] = useState(1); // 1: Congratulations with bouncing, 2: Video
  const [position, setPosition] = useState({ x: 50, y: 50 }); // Position in percentage
  const joyfulAudioRef = useRef();
  const animationRef = useRef();

  const videoPlayer = {
    minWidth: '100%',
    minHeight: '100%',
    position: 'relative',
  };

  // Stage 1: Animate the bouncing image moving around the screen
  useEffect(() => {
    if (stage === 1) {
      const moveImage = () => {
        // Generate random position (keep away from edges)
        const newX = Math.random() * 70 + 15; // 15% to 85%
        const newY = Math.random() * 70 + 15; // 15% to 85%
        setPosition({ x: newX, y: newY });
      };

      // Move every 2 seconds
      const interval = setInterval(moveImage, 2000);
      animationRef.current = interval;

      return () => clearInterval(interval);
    }
  }, [stage]);

  // Create confetti elements
  const createConfetti = () => {
    const confettiElements = [];
    const colors = ['#0066ff', '#3399ff', '#66ccff', '#0099ff', '#0033cc', '#00ccff'];
    for (let i = 0; i < 50; i++) {
      const style = {
        left: `${Math.random() * 100}%`,
        animationDelay: `${Math.random() * 3}s`,
        backgroundColor: colors[Math.floor(Math.random() * colors.length)]
      };
      confettiElements.push(<div key={i} className='confetti' style={style}></div>);
    }
    return confettiElements;
  };

  return (
    <>
      {/* Stage 1: Congratulations with confetti, bouncing image, and Joyful Jingle */}
      {stage === 1 && (
        <div className='champion-container'>
          <div className='confetti-container'>
            {createConfetti()}
          </div>
          
          <audio ref={joyfulAudioRef} autoPlay onEnded={() => setStage(2)}>
            <source src={props.music} type='audio/mp3'></source>
          </audio>

          <div className='champion-content'>
            <h1 className='champion-title'>Congratulations!</h1>
          </div>

          <img 
            src={props.rewardImage} 
            alt='Bouncing Champion' 
            className='bouncing-image-overlay'
            style={{
              left: `${position.x}%`,
              top: `${position.y}%`,
              transform: 'translate(-100%, -100%)',
              transition: 'all 2s ease-in-out',
            }}
          />
        </div>
      )}

      {/* Stage 2: Influencer video */}
      {stage === 2 && (
        <div className='champion-container'>
            <div id='influencerVideo'>
                <video
                style={videoPlayer}
                autoPlay
                onEnded={() => props.close()}
                onError={() => props.close()}
                playsInline
                >
                    <source src={props.influencerVideo} type='video/mp4'></source>
                </video>
            </div>
        </div>
      )}
    </>
  );
}

